import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../store/store";
import PaymentConditionService from '../services/PaymentConditionService';
import { loadingPaymentConditionDropdown } from '../store/slices/paymentConditions/paymentConditionSlice';

export const usePaymentCondition = () => {
  const dispatch: AppDispatch = useDispatch();

  const { paymentConditionDropdown } = useSelector(
    (state: RootState) => state.paymentCondition
  );

  const fetchPaymentConditionDropdown = async () => {
    try {
      const response = await PaymentConditionService.fetchDropdown();
      dispatch(loadingPaymentConditionDropdown(response));
    } catch (error) {
      console.error("Error al cargar payment conditions:", error);
    }
  };

  return {
    paymentConditionDropdown,
    fetchPaymentConditionDropdown,
  };
};
